import type { Language } from '@posilka/shared';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useDriverProfile } from '@posilka/client/api/drivers';
import { formatDateTime } from '@posilka/client/lib/time';
import { Row, Section } from '@/components/Section';
import { ErrorState, ListSkeleton } from '@/components/States';

/** Shafyorning ochiq profili: mashina, reyting, ✅ belgisi, oxirgi sharhlar. */
export function DriverProfilePage() {
  const { id = '' } = useParams();
  const { t, i18n } = useTranslation();
  const q = useDriverProfile(id);
  if (q.isPending) return <ListSkeleton />;
  if (q.isError) return <ErrorState error={q.error} onRetry={() => void q.refetch()} />;
  const p = q.data;
  const lang = i18n.language as Language;

  return (
    <>
      <h1 className="mb-1 px-1 font-display text-2xl font-bold tracking-tight">
        {p.firstName} {p.rating.verified && <span title={t('driver.verifiedHint')}>✅</span>}
      </h1>
      {p.rating.verified && (
        <p className="mb-3 px-1 text-sm text-hint">{t('driver.verifiedHint')}</p>
      )}
      {p.carPhotoUrl && (
        <img
          src={p.carPhotoUrl}
          alt=""
          className="mb-4 max-h-56 w-full rounded-3xl border border-line object-cover"
        />
      )}
      <Section>
        <Row label={t('driver.car')} value={`${p.carModel}, ${p.carColor}`} />
        <Row
          label={t('profile.rating')}
          value={
            p.rating.average ? `⭐ ${p.rating.average} (${p.rating.count})` : t('profile.noRating')
          }
        />
        <Row label={t('profile.completed')} value={p.rating.completedOrders} />
        {p.approvedAt && (
          <Row
            label={t('driver.memberSince')}
            value={formatDateTime(p.approvedAt, lang).split(',')[0]}
          />
        )}
      </Section>
      <Section title={t('driver.reviews')}>
        {p.reviews.length === 0 ? (
          <p className="px-5 py-4 text-sm text-hint">{t('profile.noRating')}</p>
        ) : (
          p.reviews.map((r, i) => (
            <div key={i} className="border-b border-line px-5 py-2.5 last:border-b-0">
              <p className="text-sm">
                {'⭐'.repeat(r.rating)} <span className="text-hint">· {r.authorName}</span>
              </p>
              {r.comment && <p className="mt-0.5 text-sm">{r.comment}</p>}
            </div>
          ))
        )}
      </Section>
    </>
  );
}
